import { z } from 'zod'

import { emailSchema, nanoidSchema, timestampSchema } from '@/utility'

export enum WaitlistProducts {
  Client = 'client',
}

export enum WaitlistSources {
  Client = 'client',
}

/**
 * Waitlist record for a given email. Can be used to track multiple products for an email.
 */
export const waitlistRecordSchema = z
  .object({
    uid: nanoidSchema,
    email: emailSchema,
    products: z.array(z.enum(WaitlistProducts)),
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
    metadata: z
      .record(z.string(), z.union([z.string(), z.number(), z.boolean()]))
      .optional()
      /** Trim the metadata to 50 key-value pairs. Additional protections are on this endpoint due to the lack of authentication */
      .overwrite((obj) => {
        if (!obj || Object.keys(obj).length < 50) return obj

        const trimmedObj = Object.fromEntries(Object.entries(obj).slice(0, 50))
        return trimmedObj
      }),
  })
  .meta({ id: 'waitlist-record' })
